import { ICONS, PLATFORM_THEME_COLORS, Icon } from '@thinknet-gmbh/platform-common-ui';

import { TaskExpandActionsContainer } from './task-expand-actions.styles';

const TaskExpandActions = ({ onDelete }: { onDelete: () => void }) => (
  <TaskExpandActionsContainer>
    <Icon
      icon={ICONS.trash}
      color={PLATFORM_THEME_COLORS.tone.red}
      size={22}
      rightMargin={false}
      onClick={onDelete}
    />
  </TaskExpandActionsContainer>
);

export default TaskExpandActions;
